import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const stopsApiRoutes = {
    list: apiDataManagerBaseURL + "stops/",
    listDraft: apiDataManagerBaseURL + "stopsdraft/",
    listWithoutMapPoint: apiDataManagerBaseURL + "stops/withoutmappoint/",
    listDraftWithoutMapPoint: apiDataManagerBaseURL + "stopsdraft/withoutmappoint/",
    lines: apiDataManagerBaseURL + "stops/",
    linesDraft: apiDataManagerBaseURL + "stopsdraft/",
    municipality: apiDataManagerBaseURL + "stops/",
    municipalityDraft: apiDataManagerBaseURL + "stopsdraft/",
    load: apiDataManagerBaseURL + "stops/",
    countActiveNetwork: apiDataManagerBaseURL + "stops/count/",
    countDraft: apiDataManagerBaseURL + "stopsdraft/count/",
    create: apiDataManagerBaseURL + "stops/",
    createDraft: apiDataManagerBaseURL + "stopsdraft/",
    createBulkDraft: apiDataManagerBaseURL + "stopsdraft/bulk/",
    update: apiDataManagerBaseURL + "stops/",
    updateDraft: apiDataManagerBaseURL + "stopsdraft/",
    delete: apiDataManagerBaseURL + "stops/",
    deleteDraft: apiDataManagerBaseURL + "stopsdraft/"
};

export class StopAPI {
    static list(networkEdition, provider = '', computeLines = false) {
        const url = `${stopsApiRoutes.list}${networkEdition}`;

        return API.authenticatedRequest({
            url: provider === '' ? `${url}?computeLines=${computeLines}` : `${url}?provider=${provider}&computeLines=${computeLines}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listDraft(draftNetworkEdition, provider = '', computeLines = false) {
        const url = `${stopsApiRoutes.listDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: provider === '' ? `${url}?computeLines=${computeLines}` : `${url}?provider=${provider}&computeLines=${computeLines}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listWithoutMapPoints(networkEdition, provider = '') {
        const url = `${stopsApiRoutes.listWithoutMapPoint}${networkEdition}/`;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listDraftWithoutMapPoints(draftNetworkEdition, provider = '') {
        const url = `${stopsApiRoutes.listDraftWithoutMapPoint}${draftNetworkEdition}/`;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static lines(networkEdition, id) {
        const url = `${stopsApiRoutes.lines}${networkEdition}/${id}/lines`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static linesDraft(draftNetworkEdition, id) {
        const url = `${stopsApiRoutes.linesDraft}${draftNetworkEdition}/${id}/lines`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static municipality(networkEdition, id) {
        const url = `${stopsApiRoutes.municipality}${networkEdition}/${id}/municipality`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static municipalityDraft(draftNetworkEdition, id) {
        const url = `${stopsApiRoutes.municipalityDraft}${draftNetworkEdition}/${id}/municipality`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(networkEdition, id) {
        const url = `${stopsApiRoutes.load}${networkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static countActive(networkEdition, providerId = '') {
        const url = `${stopsApiRoutes.countActiveNetwork}${networkEdition}/`;

        return API.authenticatedRequest({
            url: providerId === '' ? url : `${url}?providerId=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static countDraft(draftNetworkEdition, providerId) {
        const url = `${stopsApiRoutes.countDraft}${draftNetworkEdition}/${providerId}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(networkEdition, stop) {
        const url = `${stopsApiRoutes.create}${networkEdition}/`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(stop)
        });
    }

    static createStops(networkEdition, stops) {
        const url = `${stopsApiRoutes.create}${networkEdition}/`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(stops)
        });
    }

    static createDraft(draftNetworkEdition, stop) {
        const url = `${stopsApiRoutes.createDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(stop)
        });
    }

    static createStopsDraft(draftNetworkEdition, stops) {
        const url = `${stopsApiRoutes.createBulkDraft}${draftNetworkEdition}/`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(stops)
        });
    }

    static update(networkEdition, id, stop) {
        const url = `${stopsApiRoutes.update}${networkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(stop)
        });
    }

    static updateStops(networkEdition, stops) {
        const url = `${stopsApiRoutes.update}${networkEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(stops)
        });
    }

    static updateDraft(draftNetworkEdition, id, stop) {
        const url = `${stopsApiRoutes.updateDraft}${draftNetworkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(stop)
        });
    }

    static updateStopsDraft(draftNetworkEdition, stops) {
        const url = `${stopsApiRoutes.updateDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(stops)
        });
    }

    static delete(networkEdition, id) {
        const url = `${stopsApiRoutes.delete}${networkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteDraft(draftNetworkEdition, id) {
        const url = `${stopsApiRoutes.deleteDraft}${draftNetworkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteStops(networkEdition, stops) {
        const url = `${stopsApiRoutes.delete}${networkEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(stops)
        });
    }

    static deleteStopsDraft(draftNetworkEdition, stops) {
        const url = `${stopsApiRoutes.deleteDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(stops)
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/datamanager/StopAPI.js